import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './index.css';

const rootEl = document.getElementById('root');

createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter> {/* basename removed for Netlify */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
